<template>
    <b-modal size="lg" centered title="Intitulé du document groupé" :id="modalId">
        <template>
            <ValidationObserver ref="observer" tag="form">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group mb-2">
                            <CCAInput
                                v-model="data.name"
                                label="Titre du document"
                                inputRef="title"
                                required
                            />
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="form-group">
                            <label for="description">Notes (optionnel)</label>
                            <textarea 
                                id="description"
                                rows="6"
                                class="input-secondary-light"
                                v-model="data.description"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </template>

        <template #modal-footer="{ hide }">
            <b-button variant="outline-secondary" @click="hide()" class="btn-radius btn-secondary-light-o">
                Annuler
            </b-button>
            <b-button variant="primary" @click="handleSubmitedForm" class="btn-radius" :disabled="isSaving">
                <div v-if="isSaving" class="spinner-border spinner-sz-1"></div>
                Continuer
            </b-button>
        </template>
    </b-modal>  
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import CCAInput from '@/components/inputs/CCAInput.vue';

export default {
    props: {
        modalId: {
            type: String,
            default: 'document-label-modal',
        },
        isSaving: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CCAInput,
        ValidationObserver
    },
    data() {
        return {
            data: {
                name: '',
                description: ''
            },
        }
    },
    methods: {
        handleSubmitedForm() {
            this.$refs.observer.validate().then(success => {
                if (success) {
                    
                    this.$refs.observer.reset()
                    this.$emit('onDocumentSubmited', this.data);
                    this.data = {
                        name: '',
                        description: ''
                    };
                }
            });
        }
    }
}
</script>